import { useQuery } from "react-query";
import { get_performance_terms } from "../../../faunadb/queries/performance";
import { useFaunaContext } from "../../../providers/FaunaProvider";

export default function usePerformanceTerm() {
    const { client } = useFaunaContext();
    return useQuery('performance-term', () => get_performance_terms(client), { refetchOnWindowFocus: false });
}